module.exports = __webpack_public_path__ + "img/zs1.d0bcaac8.jpg";